// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__s_s72","close":"styles_close__QDq21"};